import { refs } from '../refs';

export function clearGallery() {
  refs.list.innerHTML = '';
}
